import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Check, Heart, MessageCircle } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-16 px-4 bg-white" data-id="element-380">
      <div className="max-w-lg md:max-w-2xl mx-auto" data-id="element-381">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="bg-white p-8 md:p-12 rounded-3xl border-2 border-[#4CAF50] shadow-lg relative overflow-hidden" data-id="element-382">
          <div className="absolute top-0 left-0 w-full h-2 bg-[#4CAF50]" data-id="element-383"></div>

          <div className="flex justify-center mb-6" data-id="element-384">
            <div className="bg-[#E8F5E9] p-5 rounded-full" data-id="element-385">
              <ShieldCheck className="w-14 h-14 text-[#4CAF50]" data-id="element-386" />
            </div>
          </div>

          <h2 className="text-2xl md:text-3xl font-black text-gray-900 mb-2 text-center" data-id="element-387">
            GARANTÍA TOTAL DE 15 DÍAS
          </h2>
          <p className="text-center text-[#4CAF50] font-bold text-sm uppercase tracking-wider mb-8" data-id="element-388">
            Sin riesgo. Sin letra chica. Sin preguntas.
          </p>

          <div className="space-y-5 text-gray-700 text-lg leading-relaxed mb-8" data-id="element-389">
            <p data-id="element-390">
              Sabemos lo que es comprar algo online y preguntarte:{' '}
              <em data-id="element-391">"¿Y si no es lo que esperaba?"</em>
            </p>
            <p data-id="element-392">
              Por eso te damos <strong data-id="element-393">15 días completos</strong> para explorar
              NutriPeques, probar las recetas, usar el sistema de planificación
              y ver los resultados en tu mesa.
            </p>
            <p data-id="element-394">
              Si en ese tiempo sentís que no te aportó valor — por el motivo que
              sea — te devolvemos el <strong data-id="element-395">100% de tu inversión</strong>. Sin
              formularios eternos. Sin justificaciones. Sin hacerte sentir mal.
            </p>
            <p className="font-bold text-gray-900" data-id="element-396">
              Un solo mensaje y te devolvemos cada centavo. Así de simple.
            </p>
          </div>

          <div className="bg-[#F1F8E9] rounded-2xl p-6 mb-8 space-y-3" data-id="element-397">
            <p className="font-bold text-gray-900 text-sm uppercase tracking-wider mb-3 flex items-center gap-2" data-id="element-398">
              <Heart className="w-4 h-4 text-[#4CAF50]" data-id="element-399" />
              ¿Por qué ofrecemos esta garantía?
            </p>
            <div className="space-y-2.5" data-id="element-400">
              <div className="flex items-start gap-2.5" data-id="element-401">
                <Check className="w-5 h-5 text-[#4CAF50] shrink-0 mt-0.5" data-id="element-402" />
                <span className="text-gray-700" data-id="element-403">
                  Porque <strong data-id="element-404">+3000 mamás</strong> ya lo usan y los
                  resultados hablan solos.
                </span>
              </div>
              <div className="flex items-start gap-2.5" data-id="element-405">
                <Check className="w-5 h-5 text-[#4CAF50] shrink-0 mt-0.5" data-id="element-406" />
                <span className="text-gray-700" data-id="element-407">
                  Porque sabemos que cuando lo pruebes, no vas a querer
                  soltarlo.
                </span>
              </div>
              <div className="flex items-start gap-2.5" data-id="element-408">
                <Check className="w-5 h-5 text-[#4CAF50] shrink-0 mt-0.5" data-id="element-409" />
                <span className="text-gray-700" data-id="element-410">
                  Porque preferimos que entres tranquila, sin presión y sin
                  miedo.
                </span>
              </div>
            </div>
          </div>

          <div className="bg-gray-50 rounded-xl p-5 flex items-start gap-4 mb-6" data-id="element-411">
            <MessageCircle className="w-8 h-8 text-[#4CAF50] shrink-0 mt-0.5" data-id="element-412" />
            <div data-id="element-413">
              <p className="text-gray-800 font-bold mb-1" data-id="element-414">¿Cómo funciona?</p>
              <p className="text-gray-600 text-sm leading-relaxed" data-id="element-415">
                Dentro de los 15 días posteriores a tu compra, simplemente
                escribinos un mensaje diciendo que querés tu reembolso. No
                necesitás dar explicaciones. Procesamos la devolución en 24–48
                horas hábiles. Cero drama.
              </p>
            </div>
          </div>

          <p className="text-center text-[#2E7D32] font-black italic text-lg" data-id="element-416">
            "El riesgo es nuestro. La tranquilidad, tuya."
          </p>
        </motion.div>
      </div>
    </section>;
}